import React, { Suspense } from 'react';
import { Route, withRouter, Switch } from "react-router-dom";
import { connect } from 'react-redux';
import { saveCompanyData, saveUserData, setCompanyLayout, saveUsers } from "./actions/index";
import Navbar from "./components/navbar";
import './App.css';
import GlobalAlert from './components/shared/global_alert';
import PageLoader from './components/shared/PageLoader';
import { getCompany } from "./modules/utils";
import { doGet } from "./modules/DataManager";

const Login = React.lazy(() => import('./components/login'));
const Forgot = React.lazy(() => import('./components/login/forgot'));
const Dashboard = React.lazy(() => import('./components/dashboard'));
const Prenotazione = React.lazy(() => import('./components/prenotazione'));
const Riepilogo = React.lazy(() => import('./components/prenotazione/riepilogo'));
const Thankyou = React.lazy(() => import('./components/prenotazione/thankyou'));
const Storico = React.lazy(() => import('./components/storico'));
const StoricoTrenord = React.lazy(() => import('./components/storico_trenord'));
const Listino = React.lazy(() => import('./components/listino'));
const Registrazione = React.lazy(() => import('./components/login/register'));
const Utenti = React.lazy(() => import('./components/utenti'));
const UtentePage = React.lazy(() => import('./components/utenti/utente'));
const Assenze = React.lazy(() => import('./components/assenze'));
const Impersona = React.lazy(() => import('./components/impersona'))
const Options = React.lazy(() => import('./components/options'))
const Mappa = React.lazy(() => import('./components/mappa'))
const Giri = React.lazy(() => import('./components/giri_cdi'));
const CdiAbsences = React.lazy(() => import('./components/cdi_absences'));
const DettaglioStorico = React.lazy(() => import('./components/storico/details'));

const mapStateToProps = (state) => {
  return {
    company_layout: state.company_layout
  }
}

const mapDispatchToProps = dispatch => {
  return {
    saveUserData: (sud) => dispatch(saveUserData(sud)),
    setCompanyLayout: (c) => dispatch(setCompanyLayout(c)),
    saveCompanyData: (c) => dispatch(saveCompanyData(c)),
    saveUsers: (u) => dispatch(saveUsers(u)),
  }
}


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    //this.gestoreClick = this.gestoreClick.bind(this);
  }
  componentDidMount() {
    let self = this;
    window.firebase.auth().onAuthStateChanged(function (userSnap) {
      if (userSnap) {
        window.firebase.firestore().collection('users').doc(userSnap.uid).get()
          .then(function (snap) {
            let user = snap.data();
            user.id = snap.id;
            const uCompany = user?.sede || user?.company
            if (uCompany) {
              self.setCompanyLayout(uCompany);
            }
            getCompany(uCompany).then((company) => {
              user.company = company;
              self.props.saveUserData(user);
              self.props.saveCompanyData(company);

              // Pre-fetch users
              doGet('/v2/b2b/users/get-users-by-company', { company: company.id })
                .then(function (res) {
                  if (res) {
                    self.props.saveUsers(res);
                  }
                })
                .catch(err => console.error("Error fetching users:", err));

              self.props.history.push("/prenotazione");
            })
          })
      } else {
        self.props.history.push("/");
      }
    });
  }
  setCompanyLayout(company) {
    window.firebase.firestore()
      .collection('companies')
      .doc(company)
      .collection('styles')
      .get()
      .then((snap) => {
        if (!snap.empty) {
          const company_layout = {};
          for (let d in snap.docs) {
            let doc = snap.docs[d];
            company_layout[doc.id] = doc.data();
          }
          this.props.setCompanyLayout(company_layout);
        }
      });
  }
  render() {
    let cssClass = '';
    let title = 'Mbility | Transport for special people';
    window.document.title = title;

    return (
      <div
        className={"wrapper " + cssClass}
        style={{
          background: '#f8fafc',
          minHeight: '100vh'
        }}
      >
        <div className='app-shell'>
          <GlobalAlert />
          <Navbar />
          {/*<Sidebar />*/}
          <Switch>
            <Suspense fallback={<PageLoader />}>
              <Route exact path="/" component={Login} />
              <Route exact path="/forgot-password" component={Forgot} />
              <Route exact path="/dashboard" component={Dashboard} />
              <Route exact path="/prenotazione/thankyou" component={Thankyou} />
              <Route exact path="/prenotazione/riepilogo" component={Riepilogo} />
              <Route exact path="/prenotazione" component={Prenotazione} />
              <Route exact path="/storico" component={Storico} />
              <Route exact path="/storico-trenord" component={StoricoTrenord} />
              <Route exact path="/listino" component={Listino} />
              <Route exact path="/utenti" component={Utenti} />
              <Route path="/utenti/:id" component={UtentePage} />
              <Route exact path="/registrazione" component={Registrazione} />
              <Route exact path="/assenze" component={Assenze} />
              <Route exact path="/mappa" component={Mappa} />
              <Route path="/users/signInWithCustomToken" component={Impersona} />
              <Route path="/options" component={Options} />
              <Route path="/giri-cdi" component={Giri} />
              <Route path="/cdi-absences" component={CdiAbsences} />
              <Route path="/dettaglio-storico" component={DettaglioStorico} />
            </Suspense>
          </Switch>
          <div id="versione">1.5.25</div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
